import FetchDocuments from '@Application/Beneficiaries/Documents/Queries/FetchDocuments';
import fetchDocuments from '@Application/Beneficiaries/Documents/fetchDocuments';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import type DocumentsListView from '@UI/Store/Documents/Views/DocumentsListView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';
import type { UseStoreQueryResult } from '@verclam/synapse';

/**
 * The generated documents of one dossier. Every reader of this list declares it here, so they share one
 * cache entry and one request.
 */
const useSubjectDocuments = (subject: SubjectAddress): UseStoreQueryResult<DocumentsListView | null> => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;

	return useStoreQuery({
		selector: (state) => state.documentsStore.documents,
		stopOn: (value) => value !== null && value.isFor(subject),
		query: () => dispatch(fetchDocuments(new FetchDocuments(facilityId, subject))),
		deps: [facilityId, subject],
	});
};

export default useSubjectDocuments;
